import { render, staticRenderFns } from "./albumManager.vue?vue&type=template&id=2fefcbba"
import script from "./albumManager.vue?vue&type=script&lang=js"
export * from "./albumManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports